<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  fill="none"
  style="width: var(--icon-width); height: var(--icon-height)"
>
  <use [attr.xlink:href]="filePath"></use>
</svg>
